import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Text,
} from '@/components/v4';

const RefireModal = ({ isOpen, onClose, isRefiring, onConfirm }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Refire Trigger</ModalHeader>
                <ModalBody>
                    <Text>
                        Are you sure you wish to refire this trigger? This will
                        execute the trigger action again with the same
                        parameters.
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <Button
                        variant="ghost"
                        mr={3}
                        onClick={onClose}
                        disabled={isRefiring}>
                        Cancel
                    </Button>
                    <Button
                        colorScheme="blue"
                        onClick={onConfirm}
                        isLoading={isRefiring}
                        loadingText="Refiring...">
                        Refire
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default RefireModal;
